import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import axios from 'axios';
import { sanitizeForDisplay } from '../utils/sanitize';

const TiktokCallback = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const params = queryString.parse(location.search);
    const [error, setError] = useState(null); // Inicializa error como null
    const [isLoading, setIsLoading] = useState(true); // Estado de carga

    useEffect(() => {
        const fetchToken = async () => {
            try {
                if (!params.code) {
                    throw new Error('No se proporcionó un código de autorización.'); // Error más específico
                }

                const formData = new FormData();
                formData.append('code', params.code);
                formData.append('type', 'tiktok_atoken'); // ¿Es esto correcto? Debería ser para obtener el access token
                formData.append('redirect_uri', process.env.REACT_APP_TIKTOK_REDIRECT);
                const response = await axios.post(process.env.REACT_APP_LAMBDA_ENDPOINT, formData);

                // Guarda el access token y el refresh token (si lo hay)
                localStorage.setItem('at_tktok', response.data.access_token);
                if (response.data.refresh_token) {
                    localStorage.setItem('rt_tktok', response.data.refresh_token);
                }

                // Redirige al usuario a la página anterior o a una página de éxito
                navigate(params.state || '/', { replace: true }); // Redireccionamiento con historial

            } catch (error) {
                console.error("Error en el callback de TikTok:", error);
                setError(sanitizeForDisplay(error.message || 'Error al procesar la autorización.'));
            } finally {
                setIsLoading(false);
            }
        };

        fetchToken(); // Llama a la función inmediatamente

    }, []);

    return (
        <>
            {isLoading && <p className="mt-5 d-block text-center">Cargando...</p>} {/* Mensaje de carga */}
            {error && <p className="mt-5 d-block text-center text-danger">{error}</p>}
        </>
    );
}

export default TiktokCallback;